(() => {
  const SELECTORS = {
    productInfo: 'product-info',
    variantSelects: 'variant-selects[data-vh-requires-haste="true"]',
    hasteOption: '[data-vh-haste-option="true"]',
    message: '[data-vh-haste-message]',
    productForm: 'product-form[data-vh-requires-haste="true"]',
    submitButton: 'button[name="add"]',
    variantInput: 'input[name="id"]',
    paymentButton: '.shopify-payment-button',
  };

  const getProductInfo = (element) => element?.closest(SELECTORS.productInfo);

  const getHasteState = (productInfo) => {
    const variantSelects = productInfo?.querySelector(SELECTORS.variantSelects);
    const hasteOption = variantSelects?.querySelector(SELECTORS.hasteOption);

    if (!variantSelects || !hasteOption) {
      return { required: false, selected: true, hasteOption: null };
    }

    const select = hasteOption.querySelector('select');
    const selected = select ? select.value !== '' : Boolean(hasteOption.querySelector('input[type="radio"]:checked'));

    return { required: true, selected, hasteOption };
  };

  const setHasteMessage = (hasteOption, show, reinforce = false) => {
    const message = hasteOption?.querySelector(SELECTORS.message);
    if (!message) return;

    message.hidden = !show;
    message.classList.toggle('is-visible', show);

    if (!show || !reinforce) return;

    message.classList.remove('is-reinforced');
    requestAnimationFrame(() => {
      message.classList.add('is-reinforced');
      window.setTimeout(() => message.classList.remove('is-reinforced'), 1400);
    });
  };

  const setPaymentButtonState = (paymentButton, disabled) => {
    if (!paymentButton) return;

    if (disabled) {
      paymentButton.hidden = true;
      paymentButton.setAttribute('aria-hidden', 'true');
      paymentButton.dataset.vhHiddenByHaste = 'true';
      return;
    }

    if (paymentButton.dataset.vhHiddenByHaste !== 'true') return;

    paymentButton.hidden = false;
    paymentButton.removeAttribute('aria-hidden');
    delete paymentButton.dataset.vhHiddenByHaste;
  };

  const setFormState = (productInfo, disabled) => {
    const productForm = productInfo?.querySelector(SELECTORS.productForm);
    if (!productForm) return;

    const submitButton = productForm.querySelector(SELECTORS.submitButton);
    const variantInput = productForm.querySelector(SELECTORS.variantInput);
    const paymentButton = productForm.querySelector(SELECTORS.paymentButton);

    if (disabled) {
      if (variantInput) {
        variantInput.disabled = true;
        variantInput.dataset.vhDisabledByHaste = 'true';
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.dataset.vhDisabledByHaste = 'true';
      }

      setPaymentButtonState(paymentButton, true);
      return;
    }

    if (variantInput?.dataset.vhDisabledByHaste === 'true') {
      variantInput.disabled = false;
      delete variantInput.dataset.vhDisabledByHaste;
    }

    if (submitButton?.dataset.vhDisabledByHaste === 'true') {
      const variantAvailable = productInfo.dataset.vhCurrentVariantAvailable;

      if (variantAvailable === 'true') {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-disabled');
        delete submitButton.dataset.vhDisabledByHaste;
      } else if (variantAvailable === 'false') {
        delete submitButton.dataset.vhDisabledByHaste;
      } else {
        return;
      }
    }

    setPaymentButtonState(paymentButton, false);
  };

  const clearInitialHasteSelection = (productInfo) => {
    if (!productInfo || productInfo.dataset.vhHasteInitialCleared === 'true') return;

    const { required, hasteOption } = getHasteState(productInfo);
    if (!required || !hasteOption) return;

    const select = hasteOption.querySelector('select');
    if (select) {
      select.value = '';
      Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
      select.querySelector('option[value=""]')?.setAttribute('selected', 'selected');
    }

    hasteOption.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.checked = false;
      input.removeAttribute('checked');
    });

    const selectedValue = hasteOption.querySelector('[data-selected-value]');
    if (selectedValue) selectedValue.textContent = '';

    productInfo.dataset.vhHasteInitialCleared = 'true';
  };

  const applyRequiredHasteState = (productInfo, reinforce = false) => {
    const { required, selected, hasteOption } = getHasteState(productInfo);
    if (!required) return;

    const shouldBlock = !selected;

    setHasteMessage(hasteOption, shouldBlock, reinforce);
    setFormState(productInfo, shouldBlock);
  };

  const applyAll = () => {
    document.querySelectorAll(`${SELECTORS.productInfo} ${SELECTORS.variantSelects}`).forEach((variantSelects) => {
      const productInfo = getProductInfo(variantSelects);
      clearInitialHasteSelection(productInfo);
      applyRequiredHasteState(productInfo);
    });
  };

  const reinforceIfMissing = (event) => {
    const productInfo = getProductInfo(event.target);
    const { required, selected } = getHasteState(productInfo);

    if (!required || selected) return;

    event.preventDefault();
    event.stopPropagation();
    applyRequiredHasteState(productInfo, true);
  };

  document.addEventListener('DOMContentLoaded', applyAll);
  document.addEventListener('product-info:loaded', (event) => {
    clearInitialHasteSelection(event.target);
    applyRequiredHasteState(event.target);
  });

  document.addEventListener('change', (event) => {
    const variantSelects = event.target.closest?.(SELECTORS.variantSelects);
    if (!variantSelects) return;

    applyRequiredHasteState(getProductInfo(variantSelects));
  });

  document.addEventListener(
    'submit',
    (event) => {
      if (event.target.closest?.(SELECTORS.productForm)) reinforceIfMissing(event);
    },
    true
  );

  document.addEventListener('click', (event) => {
    const productForm = event.target.closest?.(SELECTORS.productForm);
    if (!productForm) return;

    const clickedPurchaseControl = event.target.closest(SELECTORS.submitButton) || event.target.closest(SELECTORS.paymentButton);
    if (clickedPurchaseControl) reinforceIfMissing(event);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productInfo = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
      if (!productInfo) return;

      productInfo.dataset.vhCurrentVariantAvailable = data.variant?.available === false ? 'false' : 'true';
      applyRequiredHasteState(productInfo);
    });
  }
})();
